import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ApiClientService } from '../../services/api-client.service';

@Injectable()
export class SoundReportService extends ApiClientService {
  urlPath: string = `/sound/report`;

  constructor(api: ApiService) {
    super(api);
  }
}
